import * as React from 'react';

import { ISelectKeyboardControllerOptions } from './types';

import { processSingle } from './processSingle';
import { processMultiple } from './processMultiple';

export const processKeyboardEvent = (e: React.KeyboardEvent, options: ISelectKeyboardControllerOptions) => {
  if (options.multiple) {
    return processMultiple(e, options);
  }

  return processSingle(e, options);
};
